import { Button, Notice, PageHead } from '@kovix/ui';
import { useLocation, useNavigate } from '@tanstack/react-router';

/**
 * Kiểm thử UI 01/10/2026 — đường dẫn không khớp route nào: trước đây TanStack hiện chữ "Not Found" mặc định (tiếng Anh, ngoài khung, không lối quay lại).
 * Mockup v152 không có màn 404 riêng → theo khuôn `AccessDeniedPage` (PageHead + Notice + hai nút), hiển thị TRONG khung (route `$` dưới shell).
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div>
      <PageHead
        title="Không tìm thấy trang"
        subtitle="Đường dẫn không tồn tại hoặc chức năng đã được chuyển sang vị trí khác."
      />
      <Notice tone="info" icon="🧭">
        <div>
          Không có trang nào tại <code>{pathname}</code>. Dùng menu bên trái hoặc <b>Ctrl K</b> để tìm chức năng.
        </div>
      </Notice>
      <div style={{ marginTop: 16, display: 'flex', gap: 10 }}>
        <Button variant="primary" onClick={() => navigate({ to: '/' })}>
          Về Trung tâm vận hành
        </Button>
        <Button onClick={() => window.history.back()}>Quay lại</Button>
      </div>
    </div>
  );
}
